import { render } from "./welcomPage.vue?vue&type=template&id=15b36286&scoped=true"
import script from "./welcomPage.vue?vue&type=script&lang=js"
export * from "./welcomPage.vue?vue&type=script&lang=js"

import "./welcomPage.vue?vue&type=style&index=0&id=15b36286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b36286"]])

export default __exports__